import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLastpassComponent } from './simple-icons-lastpass.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLastpassComponent ],
    exports:      [ SimpleIconsLastpassComponent ],
    bootstrap:    []
})
export class SimpleIconsLastpassModule {}
